<template>
  <div class="my-workorder-bd tb">
    <custom-tab :list="tabData" v-model="tabIndex" @click="onTab(index)"></custom-tab>
    <div class="tab-content">
      <component v-bind:is="curTable" v-model="status" :param="param"></component>
    </div>
  </div>
</template>

<script>
/** 我的工单 */
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import myWaitReceive from './children/my_wait_receive';
import allWaitReceive from './children/all_wait_receive';
import mySolving from './children/my_solving';
import allSolving from './children/all_solving';
import myResolved from './children/my_resolved';
import allResolved from './children/all_resolved';
import myUnresolved from './children/my_unresolved';
import allUnresolved from './children/all_unresolved';

export default {
  name: 'my_workorder',
  mixins: [tableFilterValueMixins],
  components: {
    myWaitReceive,
    allWaitReceive,
    mySolving,
    allSolving,
    myResolved,
    allResolved,
    myUnresolved,
    allUnresolved,
  },

  data() {
    return {
      tabIndex: undefined,
      status: '',
    };
  },
  computed: {
    tabData() {
      const tabData = [];
      const funcView = this.funcView;
      if (funcView.my_wait_receive || funcView.my_solving || funcView.my_resolved) {
        tabData.push({
          name: this.$t('asm_my_workorder.zu_zhi_gong_dan'),
          value: '0',
        });
      }
      if (funcView.all_wait_receive || funcView.all_solving || funcView.all_resolved) {
        tabData.push({
          name: this.$t('asm_my_workorder.wo_de_gong_dan'),
          value: '1',
        });
      }
      return tabData;
    },
    itemList() {
      const itemList = [];
      const funcView = this.funcView;
      if (funcView.my_wait_receive) {
        itemList.push({
          name: this.$t('asm_my_workorder.wo_de_dai_jie_dan'),
          code: 'wait',
          compName: 'myWaitReceive',
          value: '1',
        });
      }
      if (funcView.all_wait_receive) {
        itemList.push({
          name: this.$t('asm_my_workorder.suo_you_dai_jie_dan'),
          code: 'wait',
          compName: 'allWaitReceive',
          value: '0',
        });
      }
      if (funcView.my_solving) {
        itemList.push({
          name: this.$t('asm_my_workorder.wo_de_jie_jue_zhong'),
          code: 'ing',
          compName: 'mySolving',
          value: '1',
        });
      }
      if (funcView.all_solving) {
        itemList.push({
          name: this.$t('asm_my_workorder.syjjz'),
          code: 'ing',
          compName: 'allSolving',
          value: '0',
        });
      }
      if (funcView.my_resolved) {
        itemList.push({
          name: this.$t('asm_my_workorder.wo_de_yi_jie_jue'),
          code: 'finish',
          compName: 'myResolved',
          value: '1',
        });
      }
      if (funcView.all_resolved) {
        itemList.push({
          name: this.$t('asm_my_workorder.suo_you_yi_jie_jue'),
          code: 'finish',
          compName: 'allResolved',
          value: '0',
        });
      }
      if (funcView.my_resolved) {
        itemList.push({
          name: this.$t('asm_my_workorder.wo_de_wei_jie_jue'),
          code: 'unresolved',
          compName: 'myUnresolved',
          value: '1',
        });
      }
      if (funcView.all_resolved) {
        itemList.push({
          name: this.$t('asm_my_workorder.suo_you_wei_jie_jue'),
          code: 'unresolved',
          compName: 'allUnresolved',
          value: '0',
        });
      }
      return itemList;
    },
    curTable() {
      if (this.itemList.length) {
        const item = this.itemList.find((i) => i.code === this.status && i.value === this.tabIndex);
        return item ? item.compName : '';
      } else {
        return '';
      }
    },
  },
  watch: {},
  mounted: function () {
    this.getFuncView('/workorder/my', (funcView) => {
      this.funcView = funcView;
      if (this.tabData.length) {
        this.tabIndex = this.tabData[0].value;
        const item = this.itemList.find((i) => i.value === this.tabData[0].value); // 移除了reverse()
        this.status = item ? item.code : '';
      }
    });
  },
  methods: {
    onTab(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.my-workorder-bd {
  padding: 0 !important;
  display: flex;
  flex-direction: column;

  .tab-content {
    height: 0;
    flex: 1;
    padding: 0 16px;
  }
}
</style>
